import { Bound } from "lib/@components/binding/Bound"
import { useTailoringReferenceId } from "./hooks/use-tailoring-reference-id"

export function TailoredReference({ children }) {
    const { referenceId, regimeVersion } = useTailoringReferenceId()

    if (Number.isNaN(regimeVersion)) return null

    return <Bound tailoringReferenceId={referenceId}>{children}</Bound>
}
